import request from '@/utils/request'

export function fetchAnnual(query) {
    return request({
        url: '/admin/report/annual',
        method: 'get',
        params: query
    })
}

export function fetchDepartmentAnnual(query) {
    return request({
        url: '/admin/report/department/annual',
        method: 'get',
        params: query
    })
}

export function fetchHomeData() {
    return request({
        url: '/admin/report/home',
        method: 'get'
    })
}

export function fetchStatisticData(query) {
    return request({
        url: '/admin/report/statistic',
        method: 'get',
        params: query
    })
}
